import { cva } from 'class-variance-authority'

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive hover:cursor-pointer",
  {
    variants: {
      variant: {
        default: 'bg-purple-600 text-white hover:bg-purple-700',
        destructive: 'bg-red-500 text-white hover:bg-red-600',
        outline:
          'border border-zinc-200 hover:bg-zinc-100 text-zinc-700 hover:text-zinc-900',
        secondary:
          'bg-zinc-100 text-zinc-700 hover:text-zinc-900 hover:bg-zinc-200',
        ghost: 'hover:bg-zinc-100 text-zinc-700 hover:text-zinc-900',
        link: 'underline-offset-4 hover:underline text-purple-600',
        dark: 'bg-zinc-900 text-white/90 hover:bg-zinc-800 hover:text-white',
      },
      size: {
        default: 'h-10 py-2 px-4',
        sm: 'h-8 px-3',
        lg: 'h-12 px-8',
        icon: 'h-10 w-10',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
)
